export * from './web.routes';
